module.exports = __webpack_public_path__ + "static/media/komf3.a7184918.jpg";